import $ from 'jquery';
import * as Base from './Bootstrap/Modal';
import Vue from 'vue';

const empty = (parent) => {
	do {
		parent.removeChild(parent.firstChild);
	} while (parent.firstChild !== null);
}

const html = (content, target) => {
	if (!target)
		return;

	empty(target);
	target.insertAdjacentHTML('afterbegin', content);
}

const Modal = {
	props: ['initialTitle'],
	data: function() {
		return {
			title: this.initialTitle,
		}
	},
	mixins: [Base.Mixin],
	mounted() {
		const modal = (this.$el).querySelector('.modal') || this.$el;
		const modalDialog = modal.querySelector('.modal-dialog');

		modalDialog.classList.add('modal-dialog-centered');
		modalDialog.setAttribute('role', 'dialog');
		initModal(modal);
	},
	render() {
		return (
			<Base.Wrapper>
				<div class="modal-header">
					<div class="modal-title">
						{ this.title }
					</div>
					<button class="close" data-dismiss="modal">
						<svg class="icon-close" viewBox="-18 -18 36 36">
							<path d="M-7.5,-7.5 l15,15"/>
							<path d="M-7.5,7.5 l15,-15"/>
						</svg>
					</button>
				</div>
				<div class="modal-body">
					{ this.$slots.default }
				</div>
			</Base.Wrapper>
		);
	}
}

export const initModal = (element) => $(element).modal({ show: false });

export function create({ title, body, attrs, target }) {
	const vueModal = new Vue({
		render() {
			return (
				<Modal initialTitle={ title } attrs={ attrs }>
					<div domPropsInnerHTML={ body }></div>
				</Modal>
			);
		}
	});

	if (target instanceof HTMLElement)
		vueModal.$mount(target);
	else {
		vueModal.$mount();
		document.body.appendChild(vueModal.$el);
	}

	return $(vueModal.$el);
}

const find = (selector, parent) => parent.querySelector(selector);
const title = (parent) => find('.modal-title', parent);
const body = (parent) => find('.modal-body', parent);

export const setTitle = (parent, content) => html(content, title(parent));
export const appendBody = (parent, content) => html(content, body(parent));

export default Modal;
